export default "__VITE_ASSET__BQofzUJk__"